var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222B40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16L6.62 0h3.91l6.621 16H13.17l-1.559-3.694H5.541L3.982 16H0zM8.588 3.862l-2.28 5.59h4.559l-2.28-5.59zM22.277 10.41V16h-3.406V0h7.988c1.455 0 2.495.104 3.118.312 1.056.352 1.887 1.08 2.495 2.183.448.831.672 1.735.672 2.71 0 .816-.152 1.592-.456 2.327-.288.72-.696 1.312-1.223 1.775a4.11 4.11 0 01-1.536.864c-.527.16-1.255.24-2.183.24h-5.469zm0-2.854h4.63c.831 0 1.415-.128 1.751-.384.496-.4.744-1.095.744-2.087 0-1.071-.376-1.759-1.128-2.063-.272-.111-.704-.167-1.295-.167h-4.702v4.701zM35.292 16V4.006H38.7V16h-3.407z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.293 3.006V.008h3.406v2.998h-3.406z",
    fill: "#AD0C24"
  })));
}
export default SvgApiLogo;